// Firm-level presentation: no individual profiles are published.
// These same URLs belong in the Organization JSON-LD `SAME_AS` array in index.html.
export const socialLinks = {
  linkedin: "https://www.linkedin.com/company/112082073/",
  twitter: "",
  youtube: "",
};

/** Where Skandor's senior practitioners have shipped. Firm-level, no names. */
export const shippedProof = [
  "An LLM identity platform serving over a million users in a regulated market",
  "The programme office for a $10M, five-country SAP S/4HANA and IBP transformation",
  "An ERP replacement and partner-API platform on a manufacturing floor",
  "A consumer-hardware planning-to-fulfilment rebuild, measured against a 12-week baseline",
  "An adaptive-learning platform scaled from 2K to 100K users",
];

/** What every client can hold Skandor to. */
export const principles = [
  ["Senior only.", "The people in the first call are the people who build."],
  ["Outcomes, not deliverables.", "Fees tied to a measured baseline."],
  ["Confidential by default.", "Every engagement under NDA; references on request."],
  ["Your data stays in your systems.", "We build alongside your team, not around it."],
];

/** How an engagement is staffed. */
export const engagementRoles: Array<[string, string, string]> = [
  ["ENGAGEMENT LEAD", "Senior partner", "Owns the diagnostic, the plan and the outcome. In the first call and at handover."],
  ["PER ENGAGEMENT", "Product lead", "Scope, roadmap and the definition of done with your product team."],
  ["PER ENGAGEMENT", "AI & data engineer", "Models, retrieval and the data that feeds them. In production, not in demos."],
  ["PER ENGAGEMENT", "Systems architect", "Integrations across ERP, CRM, commerce and partner APIs."],
  ["PER ENGAGEMENT", "Operations lead", "Planning, fulfilment and the handover to your people."],
];
